/**
 * Product Upsell Handlers
 * Global functions for handling product upsell add to cart and variant selection
 */

// Handle variant selection change
window.handleProductUpsellVariantChange = function (selectElement, formId, skipImage) {
  const form = document.getElementById(formId);
  if (!form) {
    console.error("Form not found:", formId);
    return;
  }

  const productJsonEl = document.getElementById("ProductJson-" + formId);
  if (!productJsonEl) {
    if (form.dataset.upsellEnhanced === "true") {
      warnProductUpsellOnce(form, 'Missing product data; continuing without this upsell.');
    } else {
      console.error("Product JSON not found for form:", formId);
    }
    return;
  }

  try {
    const product = form.dataset.upsellEnhanced === "true"
      ? readProductUpsellData(form, "ProductJson-")
      : JSON.parse(productJsonEl.textContent);
    if (!product) return;
    const selects = form.querySelectorAll('select[name^="options["]');
    const selectedOptions = Array.from(selects).map((s) => s.value);

    // Find matching variant
    const variant = productUpsellFlag(form, 'data-hide-variant-selector')
      ? product.variants.find(v => String(v.id) === form.querySelector('input[name="id"]')?.value)
      : product.variants.find((v) => selectedOptions.every((opt, i) => v.options[i] === opt));

    if (variant) {
      const hiddenInput = form.querySelector('input[name="id"]');
      if (hiddenInput) {
        hiddenInput.value = variant.id;
      }

      // Update all price displays (button, toggle, and standalone)
      if (variant.price != null) {
        const currency = document.querySelector('meta[name="currency"]')?.content || "USD";
        const formattedPrice = formatMoney(variant.price, currency);
        const container = form.closest('[class*="upsell-product-container-"]');
        if (container) {
          container.querySelectorAll('.upsell-price, [class*="upsell-toggle-price-"], [class*="upsell-product-price-"]').forEach(function (el) {
            el.textContent = form.dataset.customPrice || formattedPrice;
          });
        }
      }
      

      // Update product image to match selected variant
      var img = skipImage || form.dataset.customImage === "true" ? null : form.querySelector("img");
      if (img) {
        var imgData = variant && variant.featured_image ? variant.featured_image : null;
        if (!imgData && product.featured_image) {
          // Fallback to product featured image
          var fi = product.featured_image;
          imgData = { src: typeof fi === "string" ? fi : fi.src, alt: "" };
        }
        if (imgData && imgData.src) {
          var newSrc = imgData.src.replace(/^\/\//, "https://").split("?")[0] + "?width=150";
          if (newSrc !== img.src) {
            var preload = new Image();
            preload.onload = function () {
              img.src = newSrc;
              if (imgData.alt) img.alt = imgData.alt;
            };
            preload.src = newSrc;
          }
        }
      }
    }

    if (form.dataset.upsellEnhanced === "true") {
      updateProductUpsellSelection(form, variant);
    }

    // Disable unavailable variant option combinations
    selects.forEach(function (currentSelect, idx) {
      Array.from(currentSelect.options).forEach(function (opt) {
        var test = selectedOptions.slice();
        test[idx] = opt.value;
        opt.disabled = !product.variants.some(function (v) {
          return test.every(function (val, i) {
            return v.options[i] === val;
          });
        });
      });
    });
  } catch (error) {
    if (form.dataset.upsellEnhanced === "true") {
      warnProductUpsellOnce(form, 'Could not read the upsell variant; continuing with the main product.');
    } else {
      console.error("Error handling variant change:", error);
    }
  }
};

// Handle add to cart
window.handleProductUpsellAdd = async function (buttonElement, formId) {
  const form = document.getElementById(formId);
  if (!form) {
    console.error("Form not found:", formId);
    return;
  }

  if (form.dataset.cartAction === "attach_to_form" || isProductUpsellPreview(form)) {
    form.dataset.upsellSelected = form.dataset.upsellSelected !== "true" ? "true" : "false";
    buttonElement.setAttribute("aria-pressed", form.dataset.upsellSelected);
    syncProductUpsellParent(form.dataset.parentFormId);
    return;
  }

  const variantId = form.querySelector('input[name="id"]')?.value;
  if (!variantId) {
    console.error("No variant ID found");
    return;
  }

  const cartAction = form.dataset.cartAction || "drawer";

  // Disable button and show loading state
  const originalHTML = buttonElement.innerHTML;
  buttonElement.disabled = true;
  buttonElement.classList.add("is-loading");
  buttonElement.innerHTML = '<span class="button-spinner"></span>';

  try {
    if (cartAction === "redirect") {
      const response = await fetch(window.routes.cart_add_url + ".js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1 }],
        }),
      });
      if (!response.ok) throw new Error("Failed to add to cart");
      const text = await response.text();
      const data = JSON.parse(text);
      if (data.status) throw new Error(data.description || "Failed to add to cart");
      window.location = window.routes?.cart_url || "/cart";
      return;
    }

    // Drawer: same request as shop-cart-button-handler (FormData + sections) so we get section HTML and open drawer
    const formData = new FormData(form);
    formData.append("sections", "cart-drawer,cart-icon-bubble");
    formData.append("sections_url", window.location.pathname);

    const response = await fetch(window.routes.cart_add_url, {
      method: "POST",
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        Accept: "application/json",
      },
      body: formData,
    });

    const text = await response.text();
    let data;
    try {
      data = JSON.parse(text);
    } catch (e) {
      console.error("Cart add returned non-JSON (likely HTML). Response ok:", response.ok, "Status:", response.status);
      throw new Error("Unable to add to cart. Please try again.");
    }
    if (data.status) {
      console.error("Error adding to cart:", data.description);
      throw new Error(data.description || "Error adding product to cart");
    }

    const cartDrawer = document.querySelector("cart-drawer");
    if (cartDrawer && typeof cartDrawer.renderContents === "function") {
      cartDrawer.renderContents(data);
    }

    if (typeof upsellCarousel === "function") {
      upsellCarousel();
    }

    // Show success state
    buttonElement.classList.remove("is-loading");
    buttonElement.classList.add("upsell-add-success");
    buttonElement.innerHTML = "✓ Added!";

    // Update cart count bubble
    fetch("/cart.js")
      .then((r) => r.json())
      .then((cart) => {
        document.querySelectorAll(".cart-count-bubble, [data-cart-count]").forEach((el) => {
          el.textContent = cart.item_count;
        });
      })
      .catch(() => {});

    // Reset button after 2 seconds
    setTimeout(() => {
      buttonElement.classList.remove("upsell-add-success");
      buttonElement.innerHTML = originalHTML;
      buttonElement.disabled = false;
    }, 2000);
  } catch (error) {
    console.error("Error adding to cart:", error);

    // Show error state
    buttonElement.classList.remove("is-loading");
    buttonElement.classList.add("upsell-add-error");
    buttonElement.innerHTML = "✗ Error";

    // Reset button after 2 seconds
    setTimeout(() => {
      buttonElement.classList.remove("upsell-add-error");
      buttonElement.innerHTML = originalHTML;
      buttonElement.disabled = false;
    }, 2000);
  }
};

// Handle toggle switch add/remove from cart
window.handleProductUpsellToggle = async function (toggleElement, formId, uniqueId) {
  const attachedForm = document.getElementById(formId);
  if (attachedForm?.dataset.cartAction === "attach_to_form" || isProductUpsellPreview(attachedForm)) {
    attachedForm.dataset.upsellSelected = String(toggleElement.checked);
    syncProductUpsellParent(attachedForm.dataset.parentFormId);
    return;
  }

  // Prevent double-calling
  if (toggleElement.dataset.processing === "true") {
    return;
  }
  toggleElement.dataset.processing = "true";

  const form = document.getElementById(formId);
  if (!form) {
    console.error("Form not found:", formId);
    toggleElement.checked = !toggleElement.checked; // Revert
    toggleElement.dataset.processing = "false";
    return;
  }

  const variantId = form.querySelector('input[name="id"]')?.value;
  if (!variantId) {
    console.error("No variant ID found");
    toggleElement.checked = !toggleElement.checked; // Revert
    toggleElement.dataset.processing = "false";
    return;
  }

  // Use uniqueId to find the toggle switch more reliably
  const toggleSwitch = document.querySelector(".upsell-toggle-switch-" + uniqueId) || toggleElement.parentElement;
  const isAdding = toggleElement.checked;

  const cartAddUrl = window.routes?.cart_add_url || "/cart/add";
  const cartChangeUrl = window.routes?.cart_change_url || "/cart/change";

  // Show loading state
  if (toggleSwitch) {
    toggleSwitch.classList.add("is-loading");
  }

  try {
    if (isAdding) {
      // Add to cart
      const response = await fetch(cartAddUrl + ".js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1 }],
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to add to cart");
      }
    } else {
      // Remove from cart - first get cart to find the line item
      const cartResponse = await fetch("/cart.js");
      const cart = await cartResponse.json();

      // Find the item in cart
      const cartItem = cart.items.find((item) => item.variant_id == variantId);

      if (cartItem) {
        // Calculate new quantity (decrease by 1)
        const newQuantity = cartItem.quantity - 1;

        // Update cart
        const response = await fetch(cartChangeUrl + ".js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            id: variantId.toString(),
            quantity: newQuantity,
          }),
        });

        if (!response.ok) {
          throw new Error("Failed to remove from cart");
        }
      }
    }

    // Success - remove loading state
    if (toggleSwitch) {
      toggleSwitch.classList.remove("is-loading");
    }
    toggleElement.dataset.processing = "false";

    // Update cart count bubble
    fetch("/cart.js")
      .then((r) => r.json())
      .then((cart) => {
        document.querySelectorAll(".cart-count-bubble, [data-cart-count]").forEach((el) => {
          el.textContent = cart.item_count;
        });
      })
      .catch(() => {});

    if (typeof window.refreshCartDrawer === "function") {
      await window.refreshCartDrawer();
    }
  } catch (error) {
    console.error("Error updating cart:", error);

    // Revert toggle state on error
    toggleElement.checked = !toggleElement.checked;
    if (toggleSwitch) {
      toggleSwitch.classList.remove("is-loading");
    }
    toggleElement.dataset.processing = "false";
  }
};

// Event delegation for toggle switches - more reliable than inline handlers
document.addEventListener("DOMContentLoaded", function () {
  document.addEventListener("change", function (e) {
    if (e.target.classList.contains("upsell-toggle-input")) {
      const formId = e.target.dataset.formId;
      const uniqueId = e.target.dataset.uniqueId;
      if (formId && uniqueId) {
        handleProductUpsellToggle(e.target, formId, uniqueId);
      }
    }
  });
});
// Helper function to format money
function formatMoney(cents, currency = "USD") {
  const amount = cents / 100;

  // Try to use Shopify's money format if available
  if (typeof Shopify !== "undefined" && Shopify.formatMoney) {
    return Shopify.formatMoney(cents, Shopify.money_format || "{{amount}}");
  }

  // Fallback formatting
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: currency,
  }).format(amount);
}

// Enhanced product_upsell instances share one owner for each main product form.
// Legacy button/toggle instances never enter this path unless explicitly enabled.
const productUpsellParents = new Map();

const productUpsellWarnings = new WeakSet();

function warnProductUpsellOnce(form, message) {
  if (!form || productUpsellWarnings.has(form)) return;
  productUpsellWarnings.add(form);
  console.warn('[Product upsell] ' + message, { formId: form.getAttribute('id') });
}

function isProductUpsellData(product) {
  return Boolean(product && /^\d+$/.test(String(product.id))
    && Array.isArray(product.options) && product.options.every(option => typeof option === 'string')
    && Array.isArray(product.variants) && product.variants.length
    && product.variants.every(variant => variant && /^\d+$/.test(String(variant.id))
      && Array.isArray(variant.options) && variant.options.length === product.options.length));
}

function readProductUpsellData(form, prefix) {
  try {
    // Read attributes, not form.id: a named input can shadow form properties.
    const element = document.getElementById(prefix + form.getAttribute('id'));
    const product = JSON.parse(element?.textContent || 'null');
    if (isProductUpsellData(product)) return product;
  } catch (error) {
    // Invalid or missing app/product data must never block the main product flow.
  }
  warnProductUpsellOnce(form, 'Missing or invalid variant data; continuing without this upsell.');
  return null;
}

// Read data booleans from the DOM, including Shopify's valueless boolean form attributes.
function productUpsellFlag(form, attribute) {
  if (!form?.hasAttribute(attribute)) return false;
  const value = form.getAttribute(attribute).trim().toLowerCase();
  return value === '' || value === 'true' || value === attribute;
}

const productUpsellPreviewNotices = new WeakSet();
function isProductUpsellPreview(form) {
  if (!productUpsellFlag(form, 'data-preview-only')) return false;
  if (!productUpsellPreviewNotices.has(form)) {
    productUpsellPreviewNotices.add(form);
    console.info('[Product upsell] Preview only: this card will never add a product to cart. Main product checkout continues normally.');
  }
  return true;
}

function updateProductUpsellSelection(form, variant) {
  const selectable = productUpsellFlag(form, 'data-preview-only') || Boolean(variant?.available);
  form.dataset.upsellAvailable = String(Boolean(variant?.available));
  const checkbox = form.querySelector('[data-upsell-checkbox], .upsell-toggle-input');
  const button = form.querySelector('.upsell-button');
  if (checkbox) {
    checkbox.disabled = !selectable;
    if (checkbox.disabled) checkbox.checked = false;
  }
  if (button) button.disabled = !selectable;
  if (!selectable) {
    form.dataset.upsellSelected = "false";
    if (button) button.setAttribute('aria-pressed', 'false');
  }
  const price = form.querySelector('[data-upsell-price]');
  const compare = form.querySelector('[data-upsell-compare]');
  const currency = document.querySelector('meta[name="currency"]')?.content || 'USD';
  if (price) price.textContent = form.dataset.customPrice || (variant ? formatMoney(variant.price, currency) : '');
  if (compare) {
    compare.textContent = form.dataset.customCompare || (variant?.compare_at_price ? formatMoney(variant.compare_at_price, currency) : '');
    compare.hidden = !form.dataset.customCompare && !(variant?.compare_at_price > variant?.price);
  }
  syncProductUpsellParent(form.dataset.parentFormId);
}

// Read the main form only. Kaching owns its single-item inputs and properties.
function syncProductUpsellParent(parentId) {
  const state = productUpsellParents.get(parentId);
  if (!state || state.syncing) return;
  const parent = document.getElementById(parentId);
  if (!parent) return;
  state.syncing = true;
  try {
    const { cards } = state;
    if (!Array.isArray(cards)) {
      warnProductUpsellOnce(parent, 'Missing upsell state; continuing with the main product.');
      return;
    }
    const variantId = parent.elements.namedItem('id')?.value;
    cards.forEach(card => {
      if (!card?.form?.isConnected || card.form.dataset.mirrorParentVariant !== 'true' || !variantId || card.lastParentVariant === variantId) return;
      if (!isProductUpsellData(card.product) || !isProductUpsellData(card.parentProduct)) {
        warnProductUpsellOnce(card.form, 'Cannot mirror missing variant data; keeping the current selection.');
        return;
      }
      card.lastParentVariant = variantId;
      const parentVariant = card.parentProduct.variants.find(v => String(v.id) === String(variantId));
      if (!parentVariant) return;
      const shared = card.product.options.map((name, i) => ({ i, parentIndex: card.parentProduct.options.indexOf(name) }))
        .filter(option => option.parentIndex !== -1);
      const currentOptions = Array.from(card.form.querySelectorAll('select[name^="options["]')).map(el => el.value);
      let match;
      if (card.product.id === card.parentProduct.id) {
        match = card.product.variants.find(v => String(v.id) === String(variantId));
      } else if (shared.length) {
        const matches = card.product.variants.filter(v => shared.every(option => v.options[option.i] === parentVariant.options[option.parentIndex]));
        match = matches.find(v => v.available && v.options.every((value, i) => shared.some(option => option.i === i) || value === currentOptions[i]))
          || matches.find(v => v.available) || matches[0];
      }
      if (match) {
        card.form.querySelectorAll('select[name^="options["]').forEach((select, i) => { select.value = match.options[i]; });
        const idInput = card.form.querySelector('input[name="id"]');
        if (idInput) idInput.value = match.id;
        handleProductUpsellVariantChange(null, card.form.getAttribute('id'));
      }
    });
  } catch (error) {
    warnProductUpsellOnce(parent, 'Could not mirror the upsell variant; keeping the main product flow.');
  } finally {
    state.syncing = false;
  }
}

// Only the upsell card contributes data to the pre-add. Parent inputs are never read.
function getAttachedProductUpsellVariantIds(state, parent) {
  if (!Array.isArray(state.cards)) throw new Error('Missing upsell cards');
  const variantIds = [];
  for (const card of state.cards) {
    const form = card?.form;
    if (!form?.isConnected || form.dataset.cartAction !== 'attach_to_form') continue;
    if (form === parent || !form.closest('[class*="upsell-product-container-"]')) {
      throw new Error('Upsell form must be separate from the parent form');
    }
    const checkbox = form.querySelector('[data-upsell-checkbox], .upsell-toggle-input');
    const selected = checkbox ? checkbox.checked && !checkbox.disabled : form.dataset.upsellSelected === 'true';
    if (!selected || isProductUpsellPreview(form)) continue;
    if (!isProductUpsellData(card.product)) {
      warnProductUpsellOnce(form, 'Missing upsell variants; continuing with the main product.');
      return null;
    }
    const selects = Array.from(form.querySelectorAll('select[name^="options["]'));
    const options = selects.map(select => select.value);
    const ownVariantId = form.querySelector('input[name="id"]')?.value;
    const variant = selects.length
      ? card.product.variants.find(v => v.options.length === options.length && options.every((value, i) => v.options[i] === value))
      : card.product.variants.find(v => String(v.id) === ownVariantId);
    if (!variant || typeof variant.available !== 'boolean') {
      warnProductUpsellOnce(form, 'Missing selected upsell variant; continuing with the main product.');
      return null;
    }
    if (variant.available) variantIds.push(variant.id);
  }
  return variantIds;
}

// Preserve the original onclick's event interface when forwarding from window capture.
function runOriginalProductUpsellClick(pending, event) {
  if (pending.replayHandled) return;
  pending.replayHandled = true;
  const originalEvent = new Proxy(event, {
    get(target, key) {
      if (key === 'currentTarget' || key === 'target') return pending.button;
      const value = Reflect.get(target, key, target);
      return typeof value === 'function' ? value.bind(target) : value;
    },
  });
  pending.originalOnClick.call(pending.button, originalEvent);
}

// Window capture precedes document/app listeners on both the first click and replay.
async function handleAttachedProductUpsellClick(event) {
  const button = event.target?.closest?.('.shop-add-to-cart-button');
  const parent = button?.form;
  if (!parent) return;
  const state = productUpsellParents.get(parent.getAttribute('id'));
  if (!state) return;

  const active = state.pending;
  if (active?.replaying && active.button === button) {
    event.preventDefault();
    event.stopImmediatePropagation();
    runOriginalProductUpsellClick(active, event);
    return;
  }
  if (active) {
    event.preventDefault();
    event.stopImmediatePropagation();
    return;
  }

  // If replay is unavailable now, leave the original event completely untouched.
  if (!button.isConnected || button.matches(':disabled') ||
      button.getAttribute('aria-disabled') === 'true' ||
      parent.dataset.checkoutPending === 'true') return;
  let body, pending;
  try {
    const variantIds = getAttachedProductUpsellVariantIds(state, parent);
    if (!variantIds?.length) return;
    if (typeof button.onclick !== 'function') {
      warnProductUpsellOnce(parent, 'Missing original button handler; leaving the click untouched.');
      return;
    }
    body = JSON.stringify({ items: variantIds.map(id => ({ id, quantity: 1 })) });
    pending = {
      button, originalOnClick: button.onclick, controller: new AbortController(),
      replaying: false, replayHandled: false,
    };
  } catch (error) {
    warnProductUpsellOnce(parent, 'Could not prepare the upsell; leaving the click untouched.');
    return;
  }

  event.preventDefault();
  event.stopImmediatePropagation();
  state.pending = pending;
  let timeout;
  try {
    await Promise.resolve();
    await Promise.race([
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body,
        signal: pending.controller.signal,
      }),
      new Promise(resolve => {
        timeout = setTimeout(() => { pending.controller.abort(); resolve(); }, 5000);
      }),
    ]);
  } catch (error) {
    // A failed optional pre-add still proceeds to the original theme handler.
  } finally {
    clearTimeout(timeout);
    if (state.pending === pending) {
      pending.replaying = true;
      button.dataset.upsellAttached = '1';
      try {
        try {
          HTMLElement.prototype.click.call(button);
        } catch (error) {
          warnProductUpsellOnce(parent, 'Replay failed; continuing with the original button handler.');
        }
        // A disabled/detached button may emit no click; retain the theme's own guards.
        if (!pending.replayHandled) runOriginalProductUpsellClick(pending, event);
      } finally {
        delete button.dataset.upsellAttached;
        state.pending = null;
      }
    }
  }
}

const productUpsellPlacements = new WeakMap();

function positionProductUpsell(form) {
  if (form.dataset.upsellPlacement !== 'above_add_to_cart') return;
  const container = form.closest('[class*="upsell-product-container-"]');
  positionAboveAddToCart(container, form.dataset.parentFormId);
}

// Share the existing Kaching placement guard with stock blocks ordered before ATC.
function positionAboveAddToCart(container, parentFormId) {
  if (!container || productUpsellPlacements.has(container)) return;
  const parent = document.getElementById(parentFormId);
  const productForm = parent?.closest('product-form');
  const wrapper = productForm?.closest('.shop-add-to-cart-wrapper') || productForm?.parentElement;
  if (!container || !productForm || !wrapper) return;
  let frame = null;
  const move = () => {
    frame = null;
    // Resolve again because Kaching can replace the product-form as well as its widget.
    const currentForm = document.getElementById(parentFormId)?.closest('product-form');
    if (!currentForm || !wrapper.contains(currentForm) || currentForm.parentElement?.closest('form')) return;
    // If both are enabled, keep the stock line nearest the button without observers competing.
    const stockLine = currentForm.previousElementSibling;
    const anchor = !container.matches('[data-stock-line]') && stockLine?.matches('[data-stock-line]')
      ? stockLine : currentForm;
    if (container.parentElement !== anchor.parentElement || container.nextElementSibling !== anchor) {
      anchor.before(container);
    }
  };
  move();
  const observer = new MutationObserver(records => {
    const changedOtherNodes = records.some(record =>
      [...record.addedNodes, ...record.removedNodes].some(node => node !== container));
    if (!changedOtherNodes || frame !== null) return;
    frame = requestAnimationFrame(move);
  });
  observer.observe(wrapper, { childList: true, subtree: productForm.parentElement !== wrapper });
  // No timeout: preserve placement through late app mounts for the page lifetime.
  const cleanup = event => {
    if (!event.target.contains(wrapper) && !event.target.contains(container)) return;
    observer.disconnect();
    if (frame !== null) cancelAnimationFrame(frame);
    productUpsellPlacements.delete(container);
    document.removeEventListener('shopify:section:unload', cleanup);
  };
  document.addEventListener('shopify:section:unload', cleanup);
  productUpsellPlacements.set(container, observer);
}

function initializeProductUpsells() {
  document.querySelectorAll('form[data-upsell-enhanced="true"]').forEach(form => {
    if (form.dataset.upsellInitialized === 'true') return;
    const parent = document.getElementById(form.dataset.parentFormId);
    const product = readProductUpsellData(form, 'ProductJson-');
    const parentProduct = form.dataset.mirrorParentVariant === 'true' ? readProductUpsellData(form, 'ParentProductJson-') : null;
    form.dataset.upsellInitialized = 'true';
    form.dataset.upsellSelected = 'false';
    if (parent) {
      const parentId = parent.getAttribute('id');
      let state = productUpsellParents.get(parentId);
      if (!state) {
        state = { cards: [], pending: null };
        productUpsellParents.set(parentId, state);
      }
      state.cards = state.cards.filter(card => card.form.isConnected);
      state.cards.push({ form, product, parentProduct, lastParentVariant: null });
    }
    positionProductUpsell(form);
    if (form.dataset.cartAction === 'attach_to_form' || productUpsellFlag(form, 'data-preview-only')) {
      form.addEventListener('submit', event => event.preventDefault());
    }
    const checkbox = form.querySelector('[data-upsell-checkbox]');
    if (checkbox) {
      checkbox.checked = false;
      form.closest('.upsell-checkbox-card').addEventListener('click', event => {
        if (event.target.closest('label, input, select, option, button, a')) return;
        if (!checkbox.disabled) checkbox.click();
      });
      checkbox.addEventListener('change', async () => {
        await handleProductUpsellToggle(checkbox, form.getAttribute('id'), checkbox.dataset.uniqueId);
        if (!productUpsellFlag(form, 'data-preview-only') && form.dataset.cartAction === 'redirect' && checkbox.checked && checkbox.dataset.processing === 'false') {
          window.location = window.routes?.cart_url || '/cart';
        }
      });
    }
    handleProductUpsellVariantChange(null, form.getAttribute('id'), true);
    syncProductUpsellParent(form.dataset.parentFormId);
  });
  document.querySelectorAll('[data-stock-line][data-parent-form-id]').forEach(stockLine => {
    positionAboveAddToCart(stockLine, stockLine.dataset.parentFormId);
  });
}

// Read the owning form, never a global event's variant from another product card.
['input', 'change', 'variant:change', 'simple-variant-picker:variantChange', 'quantity:changed', 'quantity_break:changed'].forEach(name => {
  document.addEventListener(name, () => {
    productUpsellParents.forEach((state, id) => syncProductUpsellParent(id));
  });
});
window.addEventListener('variantChanged', () => productUpsellParents.forEach((state, id) => syncProductUpsellParent(id)));
document.addEventListener('shopify:section:load', initializeProductUpsells);
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeProductUpsells);
else initializeProductUpsells();

if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS?.variantChange) {
  window.subscribe(window.PUB_SUB_EVENTS.variantChange, () => {
    productUpsellParents.forEach((state, id) => syncProductUpsellParent(id));
  });
}


window.addEventListener('click', handleAttachedProductUpsellClick, true);
window.addEventListener('pageshow', event => {
  if (!event.persisted) return;
  productUpsellParents.forEach(state => {
    if (state.pending) {
      const pending = state.pending;
      state.pending = null;
      delete pending.button.dataset.upsellAttached;
      pending.controller.abort();
    }
  });
  document.querySelectorAll('.shop-add-to-cart-button[data-upsell-attached]').forEach(button => {
    delete button.dataset.upsellAttached;
  });
});
